export const ACTIONS_TO_WIN = [
  {
    order: 1,
    title: "Get Everyone On Board",
    description:
      "If nobody is onboard, no measurement will work. We need to double down together to beat this mindless virus. Let’s not be mindless too. Take action.",
    why: [
      "The virus spreads by people’s behaviour allowing it to",
      "Any single infected person can ignite the virus’s rapid spread and get out of control",
      "There are some people who do not believe the virus is real or dangerous",
      "People need to be aligned together by consistent and reliable information",
    ],
    how: [
      "Recommend appropriate behaviour by being encouraging, consistent and simple",
      "Explain clearly how people’s behaviour spreads the virus and give good examples",
      "Showcase success stories of how certain communities have gone to zero infections",
      "Set the right expectations that the road ahead requires persistence and discipline",
    ],
  },
  {
    order: 2,
    title: "Lockdown",
    description:
      "Stay at home as much as you can. Keep people distanced and prevent contagious people spreading the viruses in public places. Help each other not get infected.",
    why: [
      "Some people don’t know they’re infected and spread it unwillingly",
      "The less social activity, the less chance of the virus spreading from person to person",
      "The virus infects others by people interacting with one another and also indirectly",
      "Reducing crowded areas keeps the highly contagious virus out of the air and off surfaces",
    ],
    how: [
      "Keep a healthy distance from others so the virus doesn’t spread out",
      "Stay away from crowded places so you aren’t exposed to the virus",
      "Explain that less personal activity is expected in these challenging times",
      "Promote healthy lifestyle habits and activities for people living in lockdown areas",
    ],
  },
  {
    order: 3,
    title: "Isolation",
    description:
      "The virus spreads easier indoors. Isolating the infected helps protect healthy people from being exposed to the virus. Keep apart so the virus can’t travel.",
    why: [
      "The virus spreads easier indoors so if unwell, isolation is important",
      "Most transmission happens between family members in the same home",
      "Isolating the infected helps protect healthy people from being exposed to the virus",
      "Staying away from people helps kill off the virus because it can’t spread to others",
    ],
    how: [
      "Keep the infected and non-infected away from each other to stop the spread",
      "Create safe zones where good hygiene and cleaning is prioritised",
      "If you’re unwell or asymptomatic keep isolated so you can’t spread the virus",
      "Ensure people who need to isolate can care for themselves and protect others",
    ],
  },
  {
    order: 4,
    title: "Wear Masks",
    description:
      "It’s an airborne and surface spread virus. Coughs, sneezes, breathing out all spread the virus. Masks block transmission when you’re in the same space. Mask up.",
    why: [
      "The coronavirus is a highly contagious and easily transmitted virus",
      "It just takes one event where you’re accidentally exposed to the virus to become infected",
      "It’s a cheap and highly effective method to reduce exposure to yourself and others",
      "Face coverings limit how far and where the virus particles go in the environment",
    ],
    how: [
      "Wear a face covering when ever you go where other people have been or still around",
      "Create homemade or buy inexpensive ones. Any type is still better than none",
      "Practice good hygiene when touching your facemasks and take them off by the straps",
      "If you use reusable masks make sure to clean and dry them regularly",
      "Make sure the mask you wear covers both your nose and your mouth",
    ],
  },
  {
    order: 5,
    title: "Restrict Travel",
    description:
      "Respect travel restrictions to prevent new outbreaks, preserve existing progress, so to restore normal activities as soon as possible. Don’t let the virus in or out.",
    why: [
      "The further the virus spreads out the harder it is to trace where it came from",
      "Containment of infected people keeps existing clean places free from the virus",
      "Reducing places for people to go and do non-essential activities helps kill off the virus",
      "Unsuspecting communities can quickly become overwhelmed by just one single infection",
    ],
    how: [
      "Create reasonable travel zone restrictions to reduce virus spread opportunities",
      "If travel is essential then quarantining should be respected and properly managed",
      "Educate each other about where is safe and not safe to travel so everyone knows",
      "Promote the merits of staying local and riding out the pandemic at home sweet home",
    ],
  },
  {
    order: 6,
    title: "Protect Essential Services",
    description:
      "We need to protect what makes everyday life remain functional. Companies providing essentials should do everything they can to reduce risk for all involved.",
    why: [
      "Everyday life needs to be maintained for the continuation of civil society to function",
      "Reducing essential workers exposure to the virus means they can continue their service",
      "Essential workers are more likely to be in at risk environments where the virus spreads",
      "They have little choice in their situation and provide essential services for all of us",
    ],
    how: [
      "Educate and train essential workers on how to keep themselves and others safe",
      "Provide essential protective and preventive supplies to stop the transmission of the virus",
      "Keep a safe distance and wear a face covering if you need be near essential workers",
      "Respect the safety and wellbeing of essential workers by practicing good hygiene",
    ],
  },
  {
    order: 7,
    title: "Continuous Widespread Testing",
    description:
      "Ramp up testing. Get a test if unwell or suspect exposure. Knowing where the virus is gives us valuable information. Test often and as many people as possible.",
    why: [
      "The virus spreads silently and fast",
      "Infections can double continuously and get out of hand quickly",
      "More testing lets us all know where the virus is and where it’s growing the most",
      "Testing allows us to design control measures to restrict the spread further",
    ],
    how: [
      "Go get a test if you suspect you’ve been exposed by someone with the virus",
      "Test even if symptoms are mild or asymptomatic",
      "Tests can include genetic (PCR), CT scans, improved symptomatic screening and other",
      "Retesting someone over different times can detect delayed exposure or infection",
      "Provide enough testing kits and human resources to support the necessary testing",
    ],
  },
  {
    order: 8,
    title: "Be Healthy",
    description:
      "Strengthen the immune system by hydrating, eating well, sleeping, exercising, and breathing fresh or filtered air. Don’t let your body and mind get weak. Stay strong.",
    why: [
      "The healthier we all are the better someone infected can fight off the virus",
      "Maintaining physical and mental health allows people to be more positive in these times",
      "The human body is where the virus makes its home and a strong body can defeat it",
      "Our sense of wellbeing can impact how we feel about what is being enforced upon us",
    ],
    how: [
      "Exercise and keep fit by regular moving of your body through physical activity",
      "Keep windows open where temperatures allow for fresh air and hygienic air flow",
      "Eat healthily with a good balanced diet and get enough sleep each night",
      "Drink plenty of water and fluids to remain hydrated",
    ],
  },
  {
    order: 9,
    title: "Support Medical Care",
    description:
      "Make sure healthcare workers have access to facilities, equipment, and living essentials. Recognize their vital role and help them overcome ongoing challenges.",
    why: [
      "Healthcare workers are critical to our fight against the virus",
      "They are exposed to the virus more than anyone else in this pandemic",
      "Stress and overcapacity can quickly overwhelm facilities if an outbreak occurs",
      "Being prepared before during and after a surge of infection can alleviate breakdown",
    ],
    how: [
      "Train, educate and standardise protective and preventive procedures against exposure",
      "Prepare enough protective and medical equipment for any amount of expected surge",
      "Create safe zones and designated areas that are free from the virus for rest and repair",
      "Allow enough time between shifts for personnel to maintain a healthy body and mind",
    ],
  },
];
